export * from './CookieConsentDetails.web';
